import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load all routes except Home to reduce initial JavaScript bundle
const Guides = lazy(() => import('./pages/Guides'));
const News = lazy(() => import('./pages/News'));
const Reviews = lazy(() => import('./pages/Reviews'));
const NewsArticle = lazy(() => import('./pages/NewsArticle'));
const GettingStarted = lazy(() => import('./pages/guides/GettingStarted'));
const ChoosingRightCasino = lazy(() => import('./pages/guides/ChoosingRightCasino'));
const UnderstandingBonuses = lazy(() => import('./pages/guides/UnderstandingBonuses'));
const PaymentMethods = lazy(() => import('./pages/guides/PaymentMethods'));
const GameSelection = lazy(() => import('./pages/guides/GameSelection'));
const SafetySecurity = lazy(() => import('./pages/guides/SafetySecurity'));
const ResponsibleGambling = lazy(() => import('./pages/guides/ResponsibleGambling'));
const WithdrawalsPayouts = lazy(() => import('./pages/guides/WithdrawalsPayouts'));
const Troubleshooting = lazy(() => import('./pages/guides/Troubleshooting'));
const NewUKGamblingRegulations = lazy(() => import('./pages/news/NewUKGamblingRegulations'));
const Top5FastestPayingCasinos = lazy(() => import('./pages/news/Top5FastestPayingCasinos'));
const BestWelcomeBonusesNovember = lazy(() => import('./pages/news/BestWelcomeBonusesNovember'));
const UKCasinoMarketRecordGrowth = lazy(() => import('./pages/news/UKCasinoMarketRecordGrowth'));
const LiveDealerGamesDominatePreferences = lazy(() => import('./pages/news/LiveDealerGamesDominatePreferences'));
const CryptocurrencyPaymentsTraction = lazy(() => import('./pages/news/CryptocurrencyPaymentsTraction'));
const MobileGamingDominatesTraffic = lazy(() => import('./pages/news/MobileGamingDominatesTraffic'));
const NewResponsibleGamingInitiatives = lazy(() => import('./pages/news/NewResponsibleGamingInitiatives'));
const ProgressiveJackpotRecordHeights = lazy(() => import('./pages/news/ProgressiveJackpotRecordHeights'));
const Lottomart = lazy(() => import('./pages/reviews/Lottomart'));
const Boylesports = lazy(() => import('./pages/reviews/Boylesports'));
const Fafabet = lazy(() => import('./pages/reviews/Fafabet'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const ResponsibleGamingPage = lazy(() => import('./pages/ResponsibleGamingPage'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Suspense fallback={<div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, #1e293b, #581c87, #1e293b)' }}></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/getting-started" element={<GettingStarted />} />
          <Route path="/guides/choosing-the-right-casino" element={<ChoosingRightCasino />} />
          <Route path="/guides/understanding-bonuses" element={<UnderstandingBonuses />} />
          <Route path="/guides/payment-methods" element={<PaymentMethods />} />
          <Route path="/guides/game-selection" element={<GameSelection />} />
          <Route path="/guides/safety-security" element={<SafetySecurity />} />
          <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
          <Route path="/guides/withdrawals-payouts" element={<WithdrawalsPayouts />} />
          <Route path="/guides/troubleshooting" element={<Troubleshooting />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/new-uk-gambling-regulations-2026" element={<NewUKGamblingRegulations />} />
          <Route path="/news/top-5-fastest-paying-casinos" element={<Top5FastestPayingCasinos />} />
          <Route path="/news/best-welcome-bonuses-november-2025" element={<BestWelcomeBonusesNovember />} />
          <Route path="/news/uk-casino-market-record-growth" element={<UKCasinoMarketRecordGrowth />} />
          <Route path="/news/live-dealer-games-dominate-preferences" element={<LiveDealerGamesDominatePreferences />} />
          <Route path="/news/cryptocurrency-payments-traction" element={<CryptocurrencyPaymentsTraction />} />
          <Route path="/news/mobile-gaming-dominates-traffic" element={<MobileGamingDominatesTraffic />} />
          <Route path="/news/new-responsible-gaming-initiatives" element={<NewResponsibleGamingInitiatives />} />
          <Route path="/news/progressive-jackpot-record-heights" element={<ProgressiveJackpotRecordHeights />} />
          <Route path="/news/:slug" element={<NewsArticle />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/reviews/lottomart" element={<Lottomart />} />
          <Route path="/reviews/boylesports" element={<Boylesports />} />
          <Route path="/reviews/fafabet" element={<Fafabet />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/responsible-gaming" element={<ResponsibleGamingPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
